module.exports = __webpack_public_path__ + "43b8c605516a97a22e6d9ef3b9043ed5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gonglue1.jpg
// module id = 438
// module chunks = 0